namespace Solovis.DevExtreme {

    export interface GridCellReference {
        rowIndex: number;
        columnIndex: number;
    }

    export class DxDataGridHelper {

        private _grid: DevExpress.ui.dxDataGrid;

        constructor(grid: DevExpress.ui.dxDataGrid) {
            this._grid = grid;

            // Repeat desired events through jquery style event mechanism.
            this._grid.on("editingStart", (e) => {
                $(this).trigger("editingStart", e);
            });
        }

        public getGrid(): DevExpress.ui.dxDataGrid {
            return this._grid;
        }

        /**
         * Retrieve {rowIndex,columnIndex} for cell being actively edited. Returns null if editor is not active.
         * It's possible this may break in future, so the default should be for this to return null instead of
         * throwing an exception if it breaks (with error logged to console).
         */
        public getActiveEditCell(): GridCellReference {
            try {
                let gridAny = this._grid as any;
                if (gridAny.getController) {
                    let editing = gridAny.getController("editing");
                    if (editing) {
                        if (editing._editRowIndex >= 0 && editing._editColumnIndex >= 0) {
                            let activeEditCell = {
                                rowIndex: editing._editRowIndex,
                                columnIndex: editing._editColumnIndex,
                            };
                            return activeEditCell;
                        }
                    }
                }                
            }
            catch (ex) {
                console.log("DxDataGridHelper.getActiveEditCell failed.");
                console.log(ex);
            }

            return null;
        }


        public focusCell(cell: GridCellReference) {
            if (cell) {
                let cellElement = this._grid.getCellElement(cell.rowIndex, cell.columnIndex);
                this._grid.focus(cellElement);
            }
        }

        /**
         * Used to refocus a control after editing with a custom editor.
         * @param cellInfo
         */
        public refocusFromEditCellTemplateCellInfo(cellInfo) {
            let editRowIndex = cellInfo.rowIndex;
            let editColumnIndex = cellInfo.columnIndex;
            let editCellRef = {
                rowIndex: editRowIndex,
                columnIndex: editColumnIndex
            };

            this._grid.cancelEditData();

            setTimeout(() => {
                this.focusCell(editCellRef);
            }, 100);            
        }

        /**
         * Used to save a value and refocus the edited cell. This is necessary when saving directly with the grid
         * as opposed to using an backing edit model for a data grid rows. 
         * @param cellInfo
         */
        public saveAndRefocusFromEditCellTemplateCellInfo(cellInfo, newValue) {
            cellInfo.setValue(newValue);
            this._grid.saveEditData();
            this._grid.cancelEditData();
            this.focusCell(cellInfo);
        }

        /**
         * If the grid has enabled master detail mode, hides the detail option for a row when the provided predicate evaluates
         * to true. The type parameter T should be the type of the data object of the row.
         * @param cellInfo The cellInfo parameter from the onCellPreparedEvent
         * @param predicate An expression taking the cell's data object and returning a boolean.
         */
        public hideDetailViewWhen<T>(cellInfo: any, predicate: (rowData: T) => boolean) {
            let masterDetailOption = this._grid.option("masterDetail");
            if (masterDetailOption.enabled && cellInfo.rowType === "data" && cellInfo.column.command === "expand") {
                let data = <T>cellInfo.data;
                if (predicate(data)) {
                    cellInfo.cellElement.removeClass("dx-datagrid-expand");
                    cellInfo.cellElement.empty();
                }
            }
        }
    }

}